import { UploadedFile } from "@/modules/common/types";
import { Box, IconButton, LinearProgress, Typography } from "@mui/material";
import FileIcon from "../../ui-kit/icons/file-icon";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const FileItem = ({
  file,
  idx,
  handleDeleteFile
}: {
  file: UploadedFile;
  idx: number;
  handleDeleteFile: (id: string) => void;
}) => {
  return (
    <Box
      key={file.id}
      sx={(theme) => ({
        display: "flex",
        gap: theme.nawy.spacing.sm,
        p: theme.nawy.spacing.sm,
        alignItems: "center",
        borderTop:
          idx !== 0
            ? `1px solid ${theme.nawy.colors.semantic.border.primary}`
            : "none",
      })}
    >
      <FileIcon fileType={file.type} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Typography
          sx={(theme) => theme.nawy.typography.english.variants.body.md.regular}
        >
          {file.name}
        </Typography>
        {file.uploadStatus === "uploading" ? (
          <LinearProgress
            color="inherit"
            sx={(theme) => ({
              color: theme.nawy.colors.semantic.layer.extension.positive,
              borderRadius: theme.nawy.radius.full,
            })}
          />
        ) : (
          <Typography
            sx={(theme) => ({
              ...theme.nawy.typography.english.variants.body.sm.regular,
              color: theme.nawy.colors.semantic.text.tertiary,
            })}
          >
            {file.uploadStatus === "success" && "Processed"}
          </Typography>
        )}
      </Box>

      <IconButton onClick={() => handleDeleteFile(file.id)}>
        <DeleteOutlineOutlinedIcon />
      </IconButton>
    </Box>
  );
};

export default FileItem;
